import React from 'react';

const GuestDetailsStep = ({ guest, errors, onChange, onBack, onSubmit }) => (
  <div className="modal-step guest-details-step">
    <form onSubmit={onSubmit} className="modal-form">
      <div>
        <label>Guest First Name</label>
        <input
          type="text"
          value={guest.fname}
          onChange={(event) => onChange('fname', event.target.value)}
        />
        {errors.fname && <p className="error">{errors.fname}</p>}
      </div>

      <div>
        <label>Guest Last Name</label>
        <input
          type="text"
          value={guest.lname}
          onChange={(event) => onChange('lname', event.target.value)}
        />
        {errors.lname && <p className="error">{errors.lname}</p>}
      </div>

      <div>
        <label>Guest Email</label>
        <input
          type="email"
          value={guest.email}
          onChange={(event) => onChange('email', event.target.value)}
        />
        {errors.email && <p className="error">{errors.email}</p>}
      </div>

      <div>
        <label>Guest Phone</label>
        <input
          type="text"
          value={guest.phone}
          onChange={(event) => onChange('phone', event.target.value)}
        />
        {errors.phone && <p className="error">{errors.phone}</p>}
      </div>

      <div className="modal-form-actions">
        <button type="button" className="class-modal-submit" onClick={onBack}>
          Back
        </button>
        <button type="submit" className="class-modal-submit">
          Submit
        </button>
      </div>
    </form>
  </div>
);

export default GuestDetailsStep;

